export default "__VITE_ASSET__Dd5k6Up8__"